import MarketMilitaryInfoCard from './MarketMilitaryInfoCardContainer';

export default MarketMilitaryInfoCard;
